import { memo, useMemo } from 'react';
import { Flex } from 'antd';
import { User } from '@Types/index';
import { ReactComponent as ChevroneIcon } from '@Icons/additional/chevrone-down.svg';
import { getGrafanaEmbedURL } from '@Features/DashboardWidgets/utils/getGrafanaEmbedUrl';
import { useAppSelector } from '@Hooks/index';
import { currentToken } from '@Store/selectors/authSelector';

import commonStyle from '../../common-mobile-styles.module.css';
import styles from './component-styles.module.css';

interface LeaveBalanceMobileProps {
  user: User;
  handleGoToProfilePage: () => void;
}

const LeaveBalanceMobile: React.FC<LeaveBalanceMobileProps> = ({
  handleGoToProfilePage,
}) => {
  const authToken = useAppSelector(currentToken);

  const grafanaAnnualRemainingURL = useMemo(
    // Grafana annual widget has id = 4
    () => getGrafanaEmbedURL('4', authToken),
    [authToken]
  );

  const grafanaRemainingPercentURL = useMemo(
    // Grafana remaining widget has id = 3
    () => getGrafanaEmbedURL('3', authToken),
    [authToken]
  );

  return (
    <>
      <div className={commonStyle.header}>
        <div className={commonStyle.caption}>Leave Balance</div>
        <div className={commonStyle.link} onClick={handleGoToProfilePage}>
          <ChevroneIcon className={commonStyle.chevrone} />
        </div>
      </div>
      <div className={styles.wrapper}>
        <Flex vertical gap={14} style={{ height: '100%', width: '100%' }}>
          <div style={{ height: '85px' }}>
            <iframe
              className={commonStyle.iframe}
              src={grafanaAnnualRemainingURL}
              title="Annual & Remaining Balance"
            />
          </div>
          <div style={{ flexGrow: '1' }}>
            <iframe
              className={commonStyle.iframe}
              src={grafanaRemainingPercentURL}
              title="Remaining Percent Balance"
            />
          </div>
        </Flex>
      </div>
    </>
  );
};

export default memo(LeaveBalanceMobile);
